
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";


import { Typography } from "@mui/material";

import logo from "assets/images/logos/comparedly.png";
import "@fontsource/righteous";
import colors from "assets/theme/base/colors";

const { black, info } = colors;

// Get the Landing Page URL from environment variables
const landingPageUrl = process.env.REACT_APP_URL_LANDING;

function CoverLayout({ coverHeight = "35vh", image, children }) {
  return (
    <PageLayout>
      <MDBox
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        {/* Left Section - Logo & Name */}
        <MDBox
          sx={{
            width: "60%",
            backgroundColor: black.main,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            padding: "2rem",
            transition: "0.3s ease-in-out", // Smooth transition
            "@media (max-width: 1024px)": {
              display: "none", // Hide on small screens
            },
          }}
        >
          <MDBox display="flex" flexDirection="column" alignItems="center" gap={2}>
            {/* Clickable Logo */}
            <a href={landingPageUrl} style={{ textDecoration: "none", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img
                src={logo}
                alt="Comparedly Logo"
                style={{ width: "120px", height: "120px", cursor: "pointer" }}
              />
              <Typography
                variant="h1"
                style={{
                  color: info.main,
                  fontFamily: "'Righteous', cursive",
                  fontWeight: "bold",
                  margin: "0px",
                  cursor: "pointer",
                }}
              >
                COMPAREDLY
              </Typography>
            </a>

            {/* Header Title */}
            <Typography
              variant="h4"
              style={{
                color: "white",
                fontWeight: "bold",
                marginTop: "20px",
                textAlign: "center",
              }}
            >
              Elevate Your Social Media Strategy
            </Typography>

            {/* Subtext */}
            <Typography
              variant="body1"
              style={{
                color: "white",
                textAlign: "center",
                maxWidth: "80%",
                fontSize: "1rem",
                lineHeight: "1.5",
              }}
            >
              Discover deep insights, track engagement, and grow your influence with powerful analytics.
              Comparedly empowers you to make data-driven decisions and stand out in the digital space.
            </Typography>
          </MDBox>
        </MDBox>

        {/* Right Section - Login Form */}
        <MDBox
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            transition: "0.3s ease-in-out",
            "@media (max-width: 1024px)": {
              width: "100%", // Expand to full width when left panel is hidden
            },
          }}
        >
          <Grid container spacing={1} justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={10} md={8} lg={7} xl={6}
              sx={{
                width: "100%", maxWidth: "600px", minWidth: "450px",
                "@media (max-width: 1024px)": {
                  maxWidth: "100%", // Allow the login form to fully expand
                  minWidth: "auto",
                },
              }}
            >
              {children}
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      {/* <Footer light /> */}
    </PageLayout>
  );
}

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  coverHeight: PropTypes.string,
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
